<template>
  <div :class="`form-element form-${type}-element`">
    <FormLabel
      :required="options.required"
      :title="options.title"
      :filled="internalValue !== undefined && internalValue !== null"
      :field-type="type"
    />
    <v-checkbox
      v-for="(option, key) in options.options"
      :key="key"
      v-model="internalValue"
      :class="(key === 0) ? 'mt-0' : ''"
      :label="option.label !== undefined ? option.label : option"
      :value="option.value !== undefined ? option.value : option"
      hide-details
      @change="changeValue"
    />
    <v-checkbox
      v-if="options.custom_value"
      v-model="customValueActive"
      :label="options.custom_value_label || $t('form.elements.select.custom')"
      :value="true"
      hide-details
      @change="toggleCustomValue"
    />
    <v-text-field
      v-if="options.custom_value && customValueActive"
      :value="customValue"
      hide-details
      @input="changeCustomValue"
    />
  </div>
</template>

<script>
import FormLabel from '../FormLabel';

export default {
  components: {
    FormLabel
  },
  props: {
    value: { type: Array, default () { return []; } },
    type: { type: String, required: true },
    options: { type: Object, default: () => ({}) }
  },
  data: () => ({
    internalValue: [],
    customValueActive: false
  }),
  watch: {
    value: {
      immediate: true,
      handler: function (v) {
        if (this.internalValue === v) return;

        this.internalValue = v || [];

        const customValue = [];
        this.internalValue.forEach((el) => {
          if (this.options.options.indexOf(el) === -1) {
            customValue.push(el);
            this.customValueActive = true;
          }
        });
        this.customValue = customValue.join(', ');
      }
    }
  },
  methods: {
    changeValue () {
      this.$emit('input', this.internalValue);
    },
    changeCustomValue (v) {
      let customValueIndex = null;

      this.internalValue.forEach((el, index) => {
        if (this.options.options.indexOf(el) === -1) {
          customValueIndex = index;
        }
      });

      if (!v && customValueIndex) {
        this.internalValue.splice(customValueIndex, 1);
      } else if (customValueIndex) {
        this.internalValue[customValueIndex] = v;
      } else {
        this.internalValue.push(v);
      }

      this.changeValue();
    },
    toggleCustomValue (v) {
      if (v) return;

      let customValueIndex = null;

      this.internalValue.forEach((el, index) => {
        if (this.options.options.indexOf(el) === -1) {
          customValueIndex = index;
        }
      });

      if (customValueIndex) {
        this.internalValue.splice(customValueIndex, 1);
      }

      this.changeValue();
    }
  }
};
</script>
